import Map from "./Map";

export default Map;

export * from "./Map";
